
/* 限制最大字体尺寸 */
const resetFontSize = () => {
  let dom = document.documentElement;
  if (dom.clientWidth >= 750) {
    dom.style.fontSize = '75px'
  }
}

resetFontSize();
window.onresize = () => {
  resetFontSize();
}
